/* @ngInject */
class ShopController {
  contructor() {
    this.name = 'shop';
  }
}

export default ShopController;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/shop.controller.js
 **/